<template>
	<div
		:class="{
			'cart-summary': true,
			'cart-summary__has-appearance': showItemAppearance,
		}"
	>
		<div
			v-for="category in categories"
			:key="category"
			class="cart-category"
			:category="category"
		>
			<div class="row-cart cart-category__row-header">
				<div
					v-if="showItemTools"
					class="item-tools"
				>
					<NavButton
						class="prev"
						variant="outline-secondary"
						data-test="nav-button-prev-cart-category"
						@click="onBackClick(category)"
					/>
				</div>
				<div class="item-description">
					{{ getLinkLabel(category) }}
				</div>
				<div
					v-if="getTotalInCategory"
					class="item-total-price"
				>
					<Price
						:value="getTotalInCategory(category)"
						:system-id="systemId"
					/>
				</div>
				<div
					v-if="showDeleteCategory && !!onDeleteCategory"
					class="item-delete-icon"
				>
					<q-button
						variant="remove"
						@click="onDeleteCategory(category)"
					>
						<span class="icon"><i class="bi bi-trash3 fs-5" /></span>
					</q-button>
				</div>
				<div
					v-if="showEditCategory && !!onEditCategory"
					class="item-edit-button"
				>
					<q-button
						variant="remove"
						@click="onEditCategory(category)"
					>
						<span class="icon"><i class="bi bi-pencil-square fs-5" /></span>
						<span class="text">{{ $t("label_edit") }}</span>
					</q-button>
				</div>
			</div>
			<div
				v-if="getDateString"
				class="cart-category-date"
			>
				{{ getDateString(category) }}
			</div>
			<div
				v-for="item in getItemsInCategory(category)"
				:key="`item-${item.ItemCompoundKey ?? item.ItemId}`"
				class="cart-category-item"
			>
				<div
					class="row-cart cart-category-item__details"
					:class="{
						'has-quantifier': hasQuantifier(category),
						'has-close': canBeRemoved(category),
						'has-modifiers': item.Modifiers && item.Modifiers.length > 0
					}"
				>
					<div
						v-if="showItemTools"
						class="item-tools"
					>
						<q-button
							v-if="canBeRemoved(category)"
							variant="remove"
							@click="removeItem(item)"
						>
							<i class="bi bi-x" />
						</q-button>
					</div>
					<q-img
						v-if="showItemAppearance"
						:src="getItemImage(item)"
						alt="offer image"
						class="offer-image rounded-3"
					/>
					<div class="item-description">
						{{ getItemName(item) }}
					</div>
					<div
						class="item-quantity"
						:class="{ 'with-quantifier': hasQuantifier(category) }"
					>
						<Quantifier
							v-if="hasQuantifier(category)"
							ref="quantifiers"
							:sub-disabled="subButtonDisabled(item)"
							:label-sub="$t('label_sub')"
							:label-plus="$t('label_plus')"
							@click-sub="onSubClick(item)"
							@click-add="onAddClick(item)"
						>
							<template #btn-sub-aria-label>
								{{ $t("label_sub") }} {{ item.Title }}
							</template>
							<template #btn-add-aria-label>
								{{ $t("label_plus") }} {{ item.Title }}
							</template>
							<template #quantity-label>
								{{ item.Quantity }}
							</template>
						</Quantifier>
						<template v-else>
							{{ getItemLabel(category, item) }}
						</template>
					</div>
					<div class="item-total-price">
						<Price
							:value="item.UnitPrice * item.Quantity"
							:system-id="systemId"
						/>
					</div>
				</div>
				<div
					v-if="item.Modifiers && item.Modifiers.length > 0"
					class="row-cart cart-category-item__modifiers"
				>
					<div class="cart-item__modifiers">
						{{ listItemModifiersFormatted(item) }}
					</div>
				</div>
				<div
					v-if="item.Note"
					class="row-cart cart-category-item__note"
				>
					<p class="cart-item__note">
						{{ item.Note }}
					</p>
				</div>
			</div>
		</div>
		<div
			v-if="showTotal"
			class="row-cart cart-summary__row-footer"
		>
			<div class="total-label">
				{{ $t("label_total_wo_taxes") }}
			</div>
			<Price
				class="total-in-cart"
				:value="totalWithoutTaxes"
				:system-id="systemId"
			/>
		</div>
	</div>
</template>

<script lang="ts" src="./cart-summary-display.ts"></script>
<style lang="scss" src="./cart-summary-display.scss"></style>
